
import { ChartContainer } from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, PieChart, Pie, Legend } from 'recharts';
import { DemographicSegment } from './types';

interface DemographicChartsProps {
  segments: DemographicSegment[];
  colors: string[];
  category: string;
}

const DemographicCharts = ({ segments, colors, category }: DemographicChartsProps) => {
  if (!segments.length) return null;
  
  return (
    <div className="w-full overflow-x-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full overflow-x-hidden">
        <div className="w-full overflow-x-hidden min-w-0">
          <h3 className="text-sm font-medium mb-2">Participation by {category}</h3>
          <div className="h-64 w-full overflow-x-hidden">
            <ResponsiveContainer width="100%" height="100%" minWidth={0}>
              <PieChart>
                <Pie
                  data={segments}
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  fill="#8884d8"
                  dataKey="count"
                  nameKey="name"
                  label={({ name, percentage }) => `${name}: ${percentage}%`}
                >
                  {segments.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value, name, props) => [`${props.payload.percentage}% (${value})`, name]} />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="w-full overflow-x-hidden min-w-0">
          <h3 className="text-sm font-medium mb-2">Sentiment Analysis by {category}</h3>
          <div className="h-64 w-full overflow-x-hidden">
            <ChartContainer
              className="h-full w-full min-w-0"
              config={{
                // Create a simple chart config object with a color for each segment
                ...segments.reduce((acc, segment, index) => ({
                  ...acc,
                  [segment.name]: {
                    color: colors[index % colors.length]
                  }
                }), {})
              }}
            >
              <ResponsiveContainer width="100%" height="100%" minWidth={0}>
                <BarChart
                  data={segments}
                  margin={{ top: 5, right: 5, left: 5, bottom: 50 }}
                  maxBarSize={40}
                >
                  <XAxis 
                    dataKey="name" 
                    angle={-45}
                    textAnchor="end"
                    height={50}
                    interval={0}
                    tick={{ fontSize: 10 }}
                    width={0}
                  />
                  <YAxis domain={[0, 100]} width={35} tick={{ fontSize: 10 }} />
                  <Tooltip formatter={(value) => [`${value}%`, 'Sentiment Score']} />
                  <Bar dataKey="agreePercentage" name="Sentiment Score" fill="#3B82F6">
                    {segments.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </ChartContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemographicCharts;
